import { useLocation } from 'react-router-dom'
import { useRootContext } from './contexts/RootContext'
import React, { useEffect, useState } from 'react'

const DISMISS_KEY = 'donation-banner-dismissed-at'
const FIRST_SEEN_KEY = 'donation-banner-first-seen-at'
const FIRST_VISIT_DELAY_MS = 24 * 60 * 60 * 1000
const DISMISS_WINDOW_MS = 30 * 24 * 60 * 60 * 1000
const KOFI_URL = 'https://ko-fi.com/E1E2EPJ2T'

const hiddenPrefixes = ['/create', '/edit', '/unsubscribe', '/callback', '/admin', '/metrics']

const shouldShowOnPath = (pathname) => !hiddenPrefixes.some(prefix => pathname.startsWith(prefix))

export default function DonationBanner() {
  const location = useLocation()
  const { secondChanceAvailable } = useRootContext()
  const [dismissed, setDismissed] = useState(true)

  useEffect(() => {
    try {
      const firstSeenAt = localStorage.getItem(FIRST_SEEN_KEY)
      if (!firstSeenAt) {
        localStorage.setItem(FIRST_SEEN_KEY, String(Date.now()))
        setDismissed(true)
        return
      }

      if ((Date.now() - Number(firstSeenAt)) < FIRST_VISIT_DELAY_MS) {
        setDismissed(true)
        return
      }

      const rawValue = localStorage.getItem(DISMISS_KEY)
      if (!rawValue) {
        setDismissed(false)
        return
      }

      const dismissedAt = Number(rawValue)
      setDismissed(!dismissedAt || (Date.now() - dismissedAt) < DISMISS_WINDOW_MS)
    } catch (_error) {
      setDismissed(true)
    }
  }, [location.pathname])

  if (secondChanceAvailable || dismissed || !shouldShowOnPath(location.pathname)) return null

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()))
    setDismissed(true)
  }

  return (
    <div className="donation-banner" role="region" aria-label="Support the site">
      <div className="donation-banner-content">
        <p>
          This site is free to use and has no ads. If you are enjoying it, you can buy the developer a coffee to help keep it running.
        </p>
        <div className="donation-banner-actions">
          <a className="donation-banner-link" href={KOFI_URL} target="_blank" rel="noopener noreferrer">
            <img src='https://storage.ko-fi.com/cdn/brandasset/kofi_s_logo_nolabel.png' alt='' aria-hidden='true' />
            Buy a coffee
          </a>
          <button className="donation-banner-dismiss" type="button" onClick={dismiss}>
            Not now
          </button>
        </div>
      </div>
    </div>
  )
}
